import {css} from "@emotion/react";
import React from 'react';
import {DetailsIcon} from "../../../AirQualityMonitoring/components/DataListCard/components/DetailsIcon";
import {Table, TableProps} from "../../../AirQualityMonitoring/components/DataListCard/components/Table";
import {useAuth} from "../../../Auth";
import {C800CallLogsContext} from "../800CallLogsProvider";
import {EditSvgIcon} from "../EditSvgIcon";


export interface CallLogsSummaryTableProps {
    onEdit?(id: number): void;

    onView?(id: number): void;
}

export const CallLogsSummaryTable: React.FC<CallLogsSummaryTableProps> = ({
    onEdit,
    onView,
}) => {

    const {userRole} = useAuth();
    const {
        callLogs,
    } = React.useContext(C800CallLogsContext);

    const callListData: TableProps['data'] = [{
        name: "Call Date",
        values: callLogs.map(x => x.calledAt),
    }, {
        name: "City/Country",
        values: callLogs.map(x => x.callerCity),
    }, {
        name: "State",
        values: callLogs.map(x => x.callerState),
    }, {
        name: "Details",
        values: callLogs.map(x => <div css={css({
            display: "flex",
            flex: 1,
            alignItems: "center",
            width: 80,
            justifyContent: "center",
        })}>

            {userRole === "admin" && <EditSvgIcon
                style={{marginRight: '10px'}}
                onClick={() => onEdit?.(x.id)}
            />}

            <DetailsIcon
                onClick={() => onView?.(x.id)}/>
        </div>),
    }];

    return (
        <Table data={callListData} fullWidth={true}/>
    );
}
